// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banderoleHolder":"_2LCpWh","banderole":"_2ncOpt","xsmall":"_3ApfdL","small":"_2u_PRh","large":"_2eD3hm","banderoleInner":"_737LTM"};